export default "__VITE_ASSET__DcuazA6p__"